module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_01_activity-731af0bd684a22994d881b6aaa091ac3.jpg";